import React, { useRef } from 'react';
import './Contact.css';
import emailjs from '@emailjs/browser';
import instagramIcon from '../../assets/instagram.png';
import linkedinIcon from '../../assets/linkedin.png';
import githubIcon from '../../assets/github.png';
import emailIcon from '../../assets/gmail.png';
import { Element } from 'react-scroll';

const skills = [
  { name: 'MySQL', icon: 'fas fa-database', level: 90 },
  { name: 'JavaScript', icon: 'fab fa-js-square', level: 80 },
  { name: 'React', icon: 'fab fa-react', level: 75 },
  { name: 'SQL Server', icon: 'fab fa-react', level: 90 },
  { name: '.NET Core', icon: 'fab fa-react', level: 40 },
  { name: 'C#', icon: 'fab fa-react', level: 35 },
  { name: 'Figma', icon: 'fab fa-react', level: 90 },
  { name: 'CSS', icon: 'fab fa-css3-alt', level: 90 },
  { name: 'Design Research', icon: 'fab fa-react', level: 90},
  { name: 'C', icon: 'fab fa-react', level: 75 },
  { name: 'Github', icon: 'fab fa-react', level: 85 },
  { name: 'Python', icon: 'fab fa-react', level: 35 },
  // Add more skills as needed
];

const Contact = () => {
  const form = useRef();

  const handleMouseEnter = (e) => {
    const skillLevel = e.currentTarget.querySelector('.skillLevel');
    const skillPercentage = e.currentTarget.querySelector('.skillPercentage');
    skillLevel.style.width = skillLevel.getAttribute('data-level');
    skillPercentage.style.opacity = 1;

    let count = 0;
    const level = parseInt(skillLevel.getAttribute('data-level'));
    const interval = setInterval(() => {
      if (count < level) {
        count++;
        skillPercentage.textContent = `${count}%`;
      } else {
        clearInterval(interval);
      }
    }, 10);
  };

  const handleMouseLeave = (e) => {
    const skillLevel = e.currentTarget.querySelector('.skillLevel');
    const skillPercentage = e.currentTarget.querySelector('.skillPercentage');
    skillLevel.style.width = '0';
    skillPercentage.style.opacity = 0;
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm('service_tda2qx8', 'template_betpneg', form.current, 'x9QUYZZ_Quz3vAZSX')
      .then(
        (result) => {
          console.log(result.text);
          e.target.reset();
          alert('Email Sent Successfully!');
        },
        (error) => {
          console.log('FAILED...', error.text);
        }
      );
  };

  return (
    <>
      <Element name="skills">
        <section id="skills">
          <div id="clients">
          <h1 className="contactPageTitle">
          My SkillSet
            <div className="hoverText">(Hover over my skills!)</div>
          </h1>
            <p className="clientDesc">
              I have been lucky enough to work with a diverse set of APIs and technologies. These include various languages, frameworks, and tools. I have also worked with various databases and have experience with both front-end and back-end development. I am always looking to learn new technologies and expand my skillset beyond what I already know.
            </p>
            <div className="clientImgs">
              {skills.map((skill, index) => (
                <div key={index} className="clientImg" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                  <i className={skill.icon}></i>
                  <p>{skill.name}</p>
                  <div className="skillBar">
                    <div className="skillLevel" data-level={`${skill.level}%`}>
                      <span className="skillPercentage">{skill.level}%</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </Element>
      <Element name="contact">
        <section id="contactPage">
          <h1 className="contactPageTitle">Contact Me</h1>
          <span className="ContactDescription">Please fill out the form below to discuss any work opportunities.</span>
          <form ref={form} className="contactForm" onSubmit={sendEmail}>
            <input type="text" placeholder="Your Name" className="name" name="user_name" required />
            <input type="email" placeholder="Your Email" className="email" name="user_email" required />
            <textarea className="msg" name="message" rows="5" placeholder="Your Message" required></textarea>
            <button type="submit" className="submitBtn">Submit</button>
            <div className="links">
              <a href="https://www.instagram.com/eldinsalja/" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} alt="Instagram" className="linkIcon" />
              </a>
              <a href="https://www.linkedin.com/in/eldinsalja/" target="_blank" rel="noopener noreferrer">
                <img src={linkedinIcon} alt="LinkedIn" className="linkIcon" />
              </a>
              <a href="https://github.com/EldinSalja" target="_blank" rel="noopener noreferrer">
                <img src={githubIcon} alt="GitHub" className="linkIcon" />
              </a>
              <a href="mailto:eldin.salja@gmail.com?subject=Hello%20Eldin!&body=Hey%20man,%20just%20reaching%20out!" rel="noopener noreferrer">
                <img src={emailIcon} alt="Email" className="linkIcon" />
              </a>
            </div>
          </form>
        </section>
      </Element>
    </>
  );
}

export default Contact;